import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const items = [
  "Atendimento presencial em Manaus",
  "Atendimento em todo o Brasil",
  "Comunicação direta com o profissional",
  "Segurança jurídica e sigilo absoluto",
  "Atendimento urgente",
  "Entrega digital e física",
  "Validade nacional e internacional",
  "Mais de 15 anos de atuação comprovada",
];

const Differentiators = () => {
  return (
    <section
      data-testid="diff-section"
      className="relative py-24 md:py-32 bg-[#0A1128] text-white overflow-hidden"
    >
      {/* decorative gold line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C5A059]/60 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <p className="overline mb-5"><span className="gold-rule mr-3 align-middle" />Diferenciais</p>
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight">
            Por que escolher <br />
            <span className="italic text-[#C5A059]">Glotaris</span>.
          </h2>
          <p className="mt-6 text-white/70 text-base lg:text-lg leading-relaxed max-w-md">
            Compromisso pessoal do tradutor em cada documento. Sem intermediários,
            sem retrabalho, com prazos rigorosamente cumpridos.
          </p>
        </div>

        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-x-8 gap-y-2">
          {items.map((label, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              data-testid={`diff-item-${i}`}
              className="flex items-center gap-4 py-4 border-b border-white/10"
            >
              <span className="flex-shrink-0 w-8 h-8 rounded-full border border-[#C5A059] flex items-center justify-center">
                <Check size={14} strokeWidth={2} className="text-[#C5A059]" />
              </span>
              <span className="text-sm md:text-base text-white">{label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Differentiators;
